import React from "react";
import { Box, TablePagination } from "@mui/material";

export default function TablePagerBar({
  perPage,
  onPerPageChange,
  total,
  page,
  onPageChange,
}) {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <TablePagination
        component={"div"}
        count={Number.isFinite(total) ? total : 0}
        page={Math.max(0, (page || 1) - 1)}
        onPageChange={(e, nextPage) => onPageChange?.(e, nextPage + 1)}
        rowsPerPage={perPage}
        onRowsPerPageChange={(e) => onPerPageChange?.(e)}
        rowsPerPageOptions={[5, 10, 20, 50, 100]}
      />
    </Box>
  );
}
